import React, {memo, useState} from 'react';
import clsx from 'clsx';

import {Icon, ICON_NAMES} from '@nur-portal/ui-kit';

import {Button} from '../../../../website-ui/components/button';

import AvailableReactions from './available-reactions';

import styles from '../reactions.module.css';

const AddReactionButton = memo(({
  onReactionClick,
  commentReactionsLength,
  isFromPreview
}) => {
  const [isAvailableReactionsShow, setIsAvailableReactionsShow] = useState(false);

  const handleReactionButtonClick = () => {
    setIsAvailableReactionsShow(true);
  };

  const handleReactionClick = reactionType => {
    onReactionClick(reactionType);
    setIsAvailableReactionsShow(false);
  };

  return (
    <div className={clsx({[styles.isFromPreview]: isFromPreview})} >
      {isAvailableReactionsShow && (
        <AvailableReactions
          onReactionClick={handleReactionClick}
          onClose={() => setIsAvailableReactionsShow(false)}
          commentReactionsLength={commentReactionsLength}
        />
      )}
      <Button
        className={clsx(styles.addReactionButton, {
          [styles.reactionButtonActive]: isAvailableReactionsShow
        })}
        variant="border"
        onClick={handleReactionButtonClick}
      >
        <Icon name={ICON_NAMES.ADD_REACTION_20} className={styles.addReactionButtonIcon} />
      </Button>
    </div>
  );
});

export default AddReactionButton;
